import { gsap } from "gsap";
import { Timeline } from "gsap/gsap-core";
gsap.registerPlugin(Timeline);


document.addEventListener("DOMContentLoaded", function() {

  (function blogHeaderSlider() {

    const sliderContainer = document.querySelector(".blog_header-slider-animation");

    if (sliderContainer) {

      const imageSliderContainer = document.querySelector(".blog_header-slider-animation .block__blog_header-slider__img-container");
      const textSliderContainer = document.querySelector(".blog_header-slider-animation .block__blog_header-slider__text-container");

      if (textSliderContainer && imageSliderContainer) {

        const imageSlides = imageSliderContainer.children;
        const textSlides = textSliderContainer.children;

        const lastSlideIndex = imageSlides.length === textSlides.length ? imageSlides.length - 1 : 0;

        if (lastSlideIndex > 0) {

          const progressBarContainers = document.querySelectorAll(".blog_header-slider-animation .block__blog_header-slider__progress-bars__element");
          const progressBars = document.querySelectorAll(".blog_header-slider-animation .block__blog_header-slider__progress-bars__element__bar__inner");

          let timeline = gsap.timeline({repeat: -1, repeatDelay: 0, paused: true});

          function animateSlide(slideIndex) {

            const currentImageSlide = imageSlides[slideIndex];
            const currentTextSlide = textSlides[slideIndex];

            const nextTextSlide = slideIndex === lastSlideIndex ? textSlides[0] : textSlides[slideIndex + 1] ;
            const nextImageSlide = slideIndex === lastSlideIndex ? imageSlides[0] : imageSlides[slideIndex + 1] ;

            let tl = gsap.timeline();

            tl.set(currentImageSlide , {xPercent: 0});
            tl.set(currentTextSlide , {xPercent: 0});

            tl.from(progressBars[slideIndex],  {duration: 4, scaleX:0, transformOrigin: "0px 0px", ease: "power0"})
            tl.to(progressBars[slideIndex],  {scaleX:0, transformOrigin: "0px 0px", ease: "power0"})

            tl.fromTo(currentImageSlide, {xPercent: 0}, {xPercent: -100}, "<");
            tl.fromTo(currentTextSlide,  {xPercent: 0}, {xPercent: -100}, "<");

            tl.fromTo(nextTextSlide,  {xPercent: 100}, {xPercent: 0}, "<-=0.01");
            tl.fromTo(nextImageSlide, {xPercent: 100}, {xPercent: 0}, "<");

            return tl;
          }

          [...imageSlides].forEach((slide, index) => {
            if (index !== 0) {
              timeline.set(slide, {xPercent: 100})
            }
          });
          [...textSlides].forEach((slide, index) => {
            if (index !== 0) {
              timeline.set(slide, {xPercent: 100})
            }
          });

          [...imageSlides].forEach((imageSlide, index) => {
            timeline.add(animateSlide(index));
          });
          timeline.play();

          [...progressBarContainers].forEach((bar, index) => {
            bar.style.cursor = 'pointer';
            bar.addEventListener('click', function() {
              timeline.progress(index / progressBarContainers.length, false);
            });
          })
        }
      }
    }
  })();
});
